import { AlertTriangle } from "lucide-react";

export default function AirtimeWalletAlert({
  low,
  balance,
}: {
  low: boolean;
  balance: number;
}) {
  if (!low) return null;

  return (
    <div className="mb-6 flex items-start gap-4 rounded-3xl border border-red-200 bg-red-50 p-5">
      <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-red-100 text-red-700">
        <AlertTriangle className="h-5 w-5" />
      </div>
      <div className="flex-1 text-red-700">
        <h3 className="text-lg font-black">Low Wallet Balance</h3>
        <p className="mt-1 text-sm">
          Current Africa&apos;s Talking wallet balance is below the configured
          threshold. Please top up before the next scheduled disbursement.
        </p>
        <div className="mt-2 text-xl font-black">KES {balance.toLocaleString()}</div>
      </div>
    </div>
  );
}
